import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { convertCurrency } from '../../../shared/utils/utils'
import { MatDialog } from '@angular/material/dialog'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { TariffEditComponent } from '../tariff-edit/tariff-edit.component'

@Component({
  selector: 'tariff-table-default',
  imports: [
    MatProgressBar,
    PaginationComponent,
    MatIconModule,
    TableListTariffComponent,
  ],
  templateUrl: './tariff-table-default.component.html',
  styleUrl: './tariff-table-default.component.scss',
  standalone: true,
  providers: [],
})
export class TariffTableDefaultComponent implements OnInit {
  constructor(
    private tariffService: TariffService,
    // private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  @Output() responseItem = new EventEmitter()

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost',
      key: 'custo_formatado',
      description: 'Custo',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'custo_formatado',
      description: 'Custo Extra',
    },
    {
      keyColumn: 'validity',
      key: 'dataValidade',
      description: 'validade',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, select: true },
      description: 'Ações',
    },
  ]

  // screen: string = 'tarifário'

  ngOnInit() {
    // this.checkColumnAction()
    this.getListItems()
  }

  // checkColumnAction() {
  //   let index = this.columns.findIndex((ele: any) => {
  //     return ele.keyColumn == 'action'
  //   })
  //   if (index != -1) {
  //     this.columns[index].key = {
  //       edit: this.checkPermission('editar'),
  //       delete: this.checkPermission('deletar'),
  //     }
  //     if (!Object.values(this.columns[index].key).includes(true)) {
  //       this.columns.splice(index, 1)
  //     }
  //   }
  // }

  // checkPermission(permission: string) {
  //   return this.authService.checkPermission(permission, this.screen)
  // }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
          custo_formatado: `R$ ${convertCurrency(item.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(item.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(item.custokmExtra)}`,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.tariffService.listPagedTariff(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.tariffService
      .searchPagedTariff(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(TariffEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      minWidth: '1300px',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }

  selectItem(item: any) {
    this.responseItem.emit(item)
  }
}
